import { atom } from "jotai";
import { View } from "../types/PageInterfaces";
import { PageView } from "../types/GlobalInterfaces";

// Primitive Atom storing the active view.
export const viewIdAtom = atom<View | null>(null);

export const acceptableModes = ["Table", "Cards", "Board", "Timeline"];

// The selected layout for non default views
// (When user switches the view type away from the default for Table/Cards/Board)
export const viewSelectLayoutHistory = atom<{
  [viewID: string]: { [mode: string]: string };
}>({});

export const currentViewAtom = atom<PageView | null>(null);

// Primitive Atom for storing edit state and show/hide of Dashboards
export const editDashboardAtom = atom(false);
